// extracted by mini-css-extract-plugin
module.exports = {"container":"Card_container__3BCzV","back":"Card_back__22bjH","front":"Card_front__2MTpC","image":"Card_image__3KnJq"};